module.exports = __webpack_public_path__ + "static/img/del.6130e7c5.svg";